import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { EllipsisVertical } from "lucide-react";
import { GlobalContext } from "../../Context/GlobalContext";

const DetailsCampaign = () => {
  const { getCampaignDetails, stopCampaign } = useContext(GlobalContext);
  const location = useLocation();
  const campaign = location.state?.campaign;
  const navigate = useNavigate();
  const [campaignDetails, setCampaignDetails] = useState([]);

  useEffect(() => {
    const fetchCampaigns = async () => {
      const res = await getCampaignDetails(campaign?.code);
      if (res?.status) {
        setCampaignDetails(res.data);
      }
    };

    fetchCampaigns();
  }, [getCampaignDetails]);

  const handleStopCampaign = async () => {
    const res = await stopCampaign(campaign?.code);
  };

  const expired = campaignDetails?.status === "Expired";

  const remaining = campaignDetails?.max_signups
    ? campaignDetails.max_signups -
      Math.round(
        (campaignDetails.percentage / 100) * campaignDetails.max_signups,
      )
    : 0;

  const scannedUsers = campaignDetails?.users || [];

  if (!campaign) {
    return (
      <div className="content-part p-4">
        <p>No campaign data received.</p>
      </div>
    );
  }

  return (
    <div className="content-part bg-white px-0">
      <div className="px-3">
        <div className="d-flex justify-content-between small text-muted">
          <span>{campaignDetails?.slots_filled}</span>
          <span>{remaining} available</span>
        </div>

        <div className="progress mt-1" style={{ height: "6px" }}>
          <div
            className="progress-bar bg-primary"
            style={{
              width: `${campaignDetails?.percentage || 0}%`,
            }}
          ></div>
        </div>
      </div>

      <div className="border-0 mb-4 mt-2">
        <div className="text-center px-0">
          <div className="d-flex justify-content-center mb-3">
            <div className="qaImage">
              <img
                src={campaignDetails?.qr_image}
                alt="QR code"
                onError={(e) => {
                  e.target.onerror = null;
                  // e.target.src = images.QRCode;
                }}
              />
            </div>
          </div>
          <div className="text-center border-top pt-3 mb-3">
            {/* <small className="text-muted">
              Valid Till:{" "}
              <span className="fw-semibold">{campaignDetails?.valid_till}</span>
            </small> */}
          </div>
          {!expired && (
            <div className="d-flex align-items-center justify-content-between ps-3 pe-2">
              <div className="d-flex justify-content-center gap-3">
                <button className="btn btn-outline-primary btn-sm px-4">
                  Download QR
                </button>

                <button className="btn btn-primary btn-sm px-4">
                  Share QR
                </button>
              </div>
              <div className="">
                <div className="dropdown position-relative">
                  <button
                    className="btn btn-sm border-0 p-0"
                    data-bs-toggle="dropdown"
                    data-bs-display="static"
                  >
                    <EllipsisVertical size={24} />
                  </button>

                  <ul className="dropdown-menu1 dropdown-menu dropdown-menu-end shadow-sm mt-2">
                    <li>
                      <button
                        className="dropdown-item"
                        onClick={() => {
                          navigate("/campaign-create", {
                            state: { campaignData: campaignDetails },
                          });
                        }}
                      >
                        Edit Campaign
                      </button>
                    </li>
                    <li>
                      <button
                        className="dropdown-item text-danger"
                        onClick={() => {
                          handleStopCampaign();
                        }}
                      >
                        Stop Campaign
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="scan-section">
        <div className="scan-section-header">
          <h6>User Scan Activity</h6>
          <span>{scannedUsers.length} Users</span>
        </div>

        <div className="scan-list">
          {scannedUsers.length === 0 ? (
            <div className="text-muted text-center">No users yet</div>
          ) : (
            scannedUsers.map((user, index) => (
              <div key={index} className="scan-item">
                <span className="scan-name">{user.name}</span>
                <span className="scan-count">
                  {user.scans} Scan{user.scans > 1 ? "s" : ""}
                </span>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default DetailsCampaign;
